module.exports = "./img/0e9f27ea117238776c156decdb474156.png";